import React from 'react';
import { Link } from 'react-router-dom';

const MoodboardCard = ({ moodboard }) => {
  return (
    <div className="bg-white rounded-lg shadow-md overflow-hidden transition-transform hover:scale-105">
      <div className="h-48 overflow-hidden bg-gray-100 relative">
        {moodboard.coverImageUrl ? (
          <img 
            src={moodboard.coverImageUrl} 
            alt={moodboard.title} 
            className="w-full h-full object-cover"
          />
        ) : (
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="grid grid-cols-2 gap-1 w-full h-full p-2">
              {moodboard.items && moodboard.items.slice(0, 4).map((item, index) => (
                <div key={index} className="bg-gray-200 overflow-hidden">
                  {item.imageUrl && (
                    <img 
                      src={item.imageUrl} 
                      alt={item.title || 'Moodboard item'} 
                      className="w-full h-full object-cover"
                    />
                  )}
                </div>
              ))}
              {(!moodboard.items || moodboard.items.length === 0) && (
                <div className="col-span-2 row-span-2 flex items-center justify-center text-gray-400">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                  </svg>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
      <div className="p-4">
        <h3 className="text-xl font-semibold text-gray-800 mb-2">{moodboard.title}</h3>
        <p className="text-gray-600 text-sm mb-3">{moodboard.description}</p>
        <div className="flex justify-between items-center">
          <span className="text-sm text-gray-500">
            {moodboard.items ? moodboard.items.length : 0} items
          </span>
          <Link 
            to={`/moodboards/${moodboard.moodboardId}`}
            className="px-3 py-1 bg-primary-600 text-white rounded-md hover:bg-primary-700 transition-colors"
          >
            View
          </Link>
        </div>
      </div>
    </div>
  );
};

export default MoodboardCard;
